import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class cloneService {

    constructor() { }

    public cloneModel<T>(oldData: T): T {
        return _.cloneDeep(oldData);

      }
}